<template>
  <div class="container">
    <div class="content">
      <h2>Planning for a Rainy Day, the StingyCat Way! 🌦️🐾</h2>
      <p> Hey there, fur-iend! Life's not always a sunny window sill; sometimes it rains on our parade. That's why having a safety net is the cat's meow. 🐱
    Insure Your Nine Lives 🐾
Insurance is your plan for life's "what-ifs." Whether it's your scratching post (home), your furmobile (car), or your jet-setting adventures (travel), having the right insurance is crucial for landing on your feet.</p>

      <div class="option" @click="toggleOption('home')" :class="{ selected: isSelected('home') }">
        <span class="icon">💰 </span>
        <b>Home Insurance: Protect your purr-sonal kingdom</b> Your cardboard box is important to you.  It keeps you warm, away from rain and is a great place to cozy up and lay your head at night.  You protect it from the disasters of this world because you never know what can happen.
      </div>

      <div class="option" @click="toggleOption('car')" :class="{ selected: isSelected('car') }">
        <span class="icon">🚙</span>
        <b>Whisker Wheels Protection: Car Insurance</b> Your trusty fur-mobile needs cover too! Just like ensuring your litter box is always clean, ensuring your ride is key to smooth journeys.  Got coverage for those unexpected meow-mechanic visits?
      </div>

      <div class="option" @click="toggleOption('pet')" :class="{ selected: isSelected('pet') }">
        <span class="icon">🐈</span>
        <b>Furball Fidelity: Pet Insurance</b> For the purring pals and barking buddies in your life. Because unexpected vet visits shouldn't mean breaking the kitty bank.
      </div>

      <div class="option" @click="toggleOption('travel')" :class="{ selected: isSelected('travel') }">
        <span class="icon">🛂 </span>
        <b>Global Pawsport Peace: Travel Insurance  </b> Adventures await! But sometimes they come with sneaky surprises. Whether you're chasing birds abroad or lounging on distant beaches, be ready for anything.  Jet-setting with peace of mind?
      </div>

      <div class="option" @click="toggleOption('life')" :class="{ selected: isSelected('life') }">
        <span class="icon">🪦</span>
        <b>Legacy of Nine Lives: Life Insurance</b> Your stories, dreams, and love live on. Safeguard the future of your kittens and kin.  Is your legacy protected for all of its nine lives?
      </div>

      <div class="option" @click="toggleOption('emergency-fund')" :class="{ selected: isSelected('emergency-fund') }">
        <span class="icon">🚨</span>
        <b>Your Purr-sonal Safety Net: The Emergency Fund</b> Consider your emergency fund as your financial catnip stash.  It's there to soothe the unexpected hisses and scratches life throws your way—like vet visits for you or a sudden flea infestation for your home.  Have you set up your emergency fund with 3-6 months of expenses?
      </div>

  
    </div>
  </div><br><br><br><br><br><br>
</template>


<script>
import { onboardingStore } from '@/components/stores/onboardingStore'; // Adjust the path as necessary

export default {
  setup() {
    const store = onboardingStore();

    const toggleOption = (option) => {
      // Check if the option is already selected
      const index = store.formData.insurance.indexOf(option);
      if (index === -1) {
        // If not selected, add it to the array
        store.updateFormData({ insurance: [...store.formData.insurance, option] });
      } else {
        // If already selected, remove it from the array
        const updatedGoals = store.formData.insurance.filter(item => item !== option);
        store.updateFormData({ insurance: updatedGoals });
      }
    };

    // Helper method to check if an option is selected
    const isSelected = (option) => store.formData.insurance.includes(option);

    return { store, toggleOption, isSelected };
  },
};
</script>





<style scoped>
.container {
  background-color: #4A148C; 
 color: black;
 padding: 20px;
 border-radius: 20px;
 display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 300px;
  max-width: 800px; /* Set a maximum width */
  align-items: center; /* Centered alignment */
  margin: auto; /* Center the container on the page */
  margin-top: 0; /* Adjusted as per your requirement */
}

.content {
background-color: white;
padding: 20px;
border-radius: 10px;
color: black;
}

.option {
padding: 10px;
border: 1px solid #ccc;
border-radius: 10px;
text-align: center;
box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
cursor: pointer;
transition: transform 0.3s ease, box-shadow 0.3s ease;
margin-bottom: 10px;
}

.option:hover {
transform: translateY(-5px);
box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}


.selected {
background-color: #4A148C; /* More solid color for selection */
color: white;
}


.icon {
font-size: 24px; /* Larger icon size */
}

/* Additional style if needed */
</style>